import { ChangePasswordPageState } from '../../../../pages/ChangePasswordPage/interfaces/ChangePasswordPageState';
import { validateSequence } from './validateSequence';
import { validateSequenceFromAsciiValues } from './validateSequenceFromAsciiValues';
import { validateFormat } from './validateFormat';

export const buildValidators = (rules: ChangePasswordPageState, apiError: string): { [validatorName: string]: (value: string) => boolean } => ({
  isErrorOnSubmit: () => rules?.ErrorMessageText.length === 0,
  isValidFormat: (value: string) => validateFormat(rules, value),
  isSameChar: (value: string) => !validateFormat(rules, value) || validateSequence(value),
  isFollowingChar: (value: string) => !validateFormat(rules, value) || !validateSequence(value) || validateSequenceFromAsciiValues(value),
  isApiErrorMsg: (value: string) => value === '' || (!validateFormat(rules, value) || !validateSequence(value) || !validateSequenceFromAsciiValues(value) || !apiError),
});
